import { render, staticRenderFns } from "./RuleField.vue?vue&type=template&id=1a6ea904&"
import script from "./RuleField.vue?vue&type=script&lang=js&"
export * from "./RuleField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports